import "@coso/layout/external-dependencies";
import "@coso/layout/external-dependencies/jquery-validation";
import { ThemeManager } from "@coso/layout";
import { defineCustomElements as defineLayoutElements } from "@coso/layout/loader";
import { defineCustomElements as defineSaasElements } from "@coso/saas/loader";

defineLayoutElements();
defineSaasElements();

let layoutElement = document.querySelector("coso-layout");

layoutElement.addEventListener("componentLoaded", (event) => {
  const container = document.getElementById("site");
  const loadingElement = document.querySelector(".loading-progress");
  layoutElement.className = "visible";
  container.removeChild(loadingElement);
});
layoutElement.isMvc = window.isMvc;
layoutElement.isAuthenticated = window.isAuthenticated;
layoutElement.identityProviderEndpoint = window.identityProviderEndpoint;
layoutElement.shellEndpoint = window.shellEndpoint;
layoutElement.dashboardEndpoint = window.dashboardEndpoint;
layoutElement.menuLogoHref = "/";
layoutElement.tenantName = window.tenantName;
layoutElement.userName = window.userName;
layoutElement.supportsMultiTheme = true;
layoutElement.supportsTenantRename = true;
layoutElement.dataCenterEU = window.dataCenter == "ProductiveEU";
layoutElement.dataCenterUS = window.dataCenter == "Productive";

const heroElement = document.querySelector("coso-hero");
if (heroElement) {
  heroElement.heroTitle = "Welcome to Connecting Software SaaS Portal";
  heroElement.subtitle = "Activate, configure and run our cloud solutions";
  heroElement.buttonContent = "Sign In";
  heroElement.showButton = true;
  heroElement.buttonAction = () => {
    const loginForm = document.getElementById("loginForm");
    if (loginForm) {
      loginForm.submit();
    }
  };
}

const landingProductElements = document.querySelectorAll("coso-landing-product");
const baseAssetPath = document.getElementById("BaseUrl")?.dataset.url + "dist";

landingProductElements.forEach((landingProductElement) => {
  landingProductElement.baseAssetPath = baseAssetPath;
  landingProductElement.heading = landingProductElement.dataset.heading || "";
  landingProductElement.linkLabel = landingProductElement.dataset.linkLabel || "";
  landingProductElement.linkHref = landingProductElement.dataset.linkHref || "";
  landingProductElement.logos = (landingProductElement.dataset.logos || "")
    .split(",")
    .map((logo) => logo.trim())
    .filter(Boolean);
});

const footerElement = document.querySelector("coso-footer");
footerElement.contactUsLink = {
  href: "https://portal.connecting-software.com/support/create-case/?subjectid=" + window.portalSubjectId + "&cs_deploymenttype=768880000&tenantid=" + window.tenantId,
  target: "_blank",
};

footerElement.termsAndConditionsLink = {
  href: window.portalEndpoint + "/support/SaaSServiceAgreement",
  target: "_blank",
};

footerElement.cookiesLink = {
  href: window.portalEndpoint + "/support/SaaSCookiesPolicy",
  target: "_blank",
};

footerElement.releaseNotesLink = { href: "/Support/ReleaseNotes" };
footerElement.productVersion = "19.19.0";

ThemeManager.instance.theme$.subscribe((theme) => {
  const helperIframe = document.getElementById("helpSliderIframe");
  let serviceId = 0;
  switch (window.productArea) {
    case "PortOfTrust": {
      serviceId = 9;
      break;
    }
  }

  toggleImages(theme);
  if (helperIframe) {
    helperIframe.src = window.shellEndpoint + "HelpSlider?serviceId=" + serviceId + "&theme=" + theme;
  }
});

function setBannerSrc(elementId, urlPattern, theme) {
  let url = window.portalEndpoint + urlPattern.replace("[theme]", theme);
  $(`#${elementId}`)?.attr("srcset", url);
}

function toggleImages(theme) {
  const banners = [
    { id: "saas-banner", pattern: "/Content/Img/SaaS-[main-banner-slider]-[theme].jpg" },
    { id: "exchange-banner", pattern: "/Content/Img/exchange-server-sync-[main-banner-slider]-[theme].jpg" },
    { id: "replicator-banner", pattern: "/Content/Img/CB-replicator-[main-banner-slider]-[theme].jpg" },
    { id: "doc-extractor-banner", pattern: "/Content/Img/Document-Extractor-[main-banner-slider]-[theme].jpg" },
    { id: "seamless-banner", pattern: "/Content/Img/CB-dynamics-365-seamless-attachment-extractor[main-banner-slider]-[theme].jpg" },
    { id: "mobile-saas-banner", pattern: "/Content/Img/Mobile-saas-platform-saas-[theme].jpg" },
    { id: "mobile-exchange-banner", pattern: "/Content/Img/Mobile-saas-platform-exchange_2-[theme].jpg" },
    { id: "mobile-replicator-banner", pattern: "/Content/Img/Mobile-saas-platform-replicator-[theme].jpg" },
    { id: "mobile-doc-extractor-banner", pattern: "/Content/Img/Mobile-saas-platform-extractor_2-[theme].jpg" },
    { id: "mobile-seamless-banner", pattern: "/Content/Img/Mobile-saas-platform-cb-dynamics-365-seamless-attachment-extractor-[theme].jpg" },
  ];

  banners.forEach((banner) => setBannerSrc(banner.id, banner.pattern, theme));
}
